import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import AddProject from './add-project';
import { ProjectList } from './project-list';
import { useTable } from '@app/components/table';
import { getProjects } from '../slice';
import { selectProjectState } from '../selector';
import { useAuthRolePermissions } from '@app/utils';

const ProjectsPage = () => {
  const dispatch = useDispatch();
  const tableProps = useTable();
  const addProjectDialog = useDialog();

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectProjectState,
    errorShown: true,
  });
  const searchProps = useSearch({
    data: data?.projects,
    fields: ['name', 'priority', 'status', 'startDate', 'endDate', 'id'],
  });
  const { hasPermission } = useAuthRolePermissions();
  const canAddProject = hasPermission('Projects', 'w');

  return (
    <>
      <Header
        title={Strings.page_title.projects}
        helperText={''}
        actionButtonTitle={canAddProject ? Strings.button.addNew : undefined}
        onClickActionButton={addProjectDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <ProjectList
        tableProps={tableProps}
        loading={loading}
        rows={searchProps.filteredRows}
        canAddProject={canAddProject}
      />

      {addProjectDialog.visible && <AddProject open onClose={addProjectDialog.hide} />}
    </>
  );
};

export { ProjectsPage };
